window.moment = require('moment')